import ActionLinkButton from '@/common/components/ActionLinkButton'
import { truncateText } from '@/common/utils/formatters'
import { TmaisFaqData, TmaisFaqTableItem } from '@/features/tmaisFaqs/types/tmaisFaq.type'
import { Tooltip } from 'react-tooltip'

export class TmaisFaqsTransformer {
  static tableTransformer() {
    return (faqs: TmaisFaqData[] = []): TmaisFaqTableItem[] =>
      faqs.map((faq) => ({
        position: String(faq.position),
        question: (
          <>
            <p data-tooltip-id={`${faq.id}_question_tooltip`} className="w-fit">
              {truncateText(faq.question, 64)}
            </p>

            {faq.question?.length > 64 && (
              <Tooltip id={`${faq.id}_question_tooltip`} className="z-50">
                {faq.question}
              </Tooltip>
            )}
          </>
        ),
        actions: <ActionLinkButton linkTo={faq.id} operationKlassToCheckPermission="Admin::Tmais::Faqs::Show" />,
      }))
  }
}
